/* ==========================================================================
   EQ: Newsletter - wyrazniejszy rabat 10% (16.10.2026)
   Ladowany w snippets/eq-default-24h-filter.liquid (defer).
   - pierwsze zdanie tekstu z rabatem ("... 10% rabatu ...") jako wieksza, pogrubiona linia,
   - nad polem e-mail krotka notka "Wpisz swoj e-mail, aby otrzymac 10% rabatu".
   Dziala tylko, gdy tekst sekcji zawiera "10% rabatu" (wersja polska) - inne jezyki bez zmian.
   Tresc sekcji edytujesz jak dotad w edytorze motywu; ten skrypt tylko ja wyroznia.
   Powrot: usun wiersz z tym plikiem w snippets/eq-default-24h-filter.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var NOTE = 'Wpisz swój e-mail, aby otrzymać 10% rabatu';
  var RX = /10\s?%\s*rabatu/i;

  function enhance(section) {
    var texts = section.querySelectorAll('.newsletter__text');
    var found = false;

    texts.forEach(function (t) {
      if (t.querySelector('.eq-nl-lead')) { found = true; return; }
      var p = t.querySelector('p') || t;
      var html = p.innerHTML;
      if (!RX.test(p.textContent)) return;
      found = true;
      // Pierwsze zdanie (do pierwszej kropki / wykrzyknika) z rabatem -> osobna, wieksza linia
      var m = /^([\s\S]*?[.!])(\s|$)/.exec(html);
      if (m && RX.test(m[1].replace(/<[^>]+>/g, ''))) {
        p.innerHTML = '<span class="eq-nl-lead">' + m[1].replace(RX, '<strong>$&</strong>') + '</span>' + html.slice(m[0].length);
      } else {
        p.innerHTML = html.replace(RX, '<strong class="eq-nl-lead eq-nl-lead--inline">$&</strong>');
      }
    });

    if (!found) return;

    section.querySelectorAll('.newsletter__form').forEach(function (form) {
      if (form.querySelector('.eq-nl-note')) return;
      var field = form.querySelector('.newsletter__field');
      var input = form.querySelector('input[type="email"]');
      if (!field || !input) return;
      var note = document.createElement('p');
      note.className = 'eq-nl-note';
      note.id = (input.id || 'eq-nl') + '-note';
      note.textContent = NOTE;
      field.parentNode.insertBefore(note, field);
      input.setAttribute('aria-describedby', note.id);
    });
  }

  function init() {
    document.querySelectorAll('.newsletter').forEach(enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Edytor motywu przeladowuje sekcje - wyroznij ponownie
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('.newsletter').forEach(enhance);
  });
})();
